import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LicencedModuleXatenaModules } from 'net-api-lib';
import { map } from 'rxjs';
import { HomeRouteNames } from '../../shared/routing.constants';
import { UserInfoService } from '../user-info.service';

export const MiniTenderModuleGuard: CanActivateFn = () => {
  const userInfoService = inject(UserInfoService);
  const router = inject(Router);

  return userInfoService.getUserInfo().pipe(
    map(userInfo => {
      const hasModule =
        userInfo?.company.licencedModules.includes(
          LicencedModuleXatenaModules.MiniTender
        ) ?? false;

      if (!hasModule) {
        router.navigate([HomeRouteNames.ModuleBase, HomeRouteNames.Dashboard]);
      }

      return hasModule;
    })
  );
};
